import React, { useContext, useEffect } from 'react'
import {
    Switch,
    Route,
    Redirect,
    useRouteMatch,
    useParams
} from "react-router-dom";
import { UserContext } from '../../context/provider/UserProvider';

import { LayoutMaster } from '../modules/layout/LayoutMaster';
import { PrivateRoute } from '../components/PrivateRoute';

import { Recargas } from '../pages/Recargas/Recargas';
import { UsuariosAplicativo } from '../pages/Registros/UsuariosAplicativo';
import { ProfilePage } from '../modules/profile/ProfilePage';
import { UsuariosPlataforma } from '../pages/Registros/UsuariosPlataforma';
import { Historial } from '../pages/Historial';

import { PersonasPlataforma } from '../pages/Registros/PersonasPlataforma';
import { EnlaceUnidades } from '../pages/GeneradorQr/EnlaceUnidades';
import { LibroReclamaciones } from '../pages/AtencionCliente/LibroReclamaciones';
import { Permisos } from '../pages/configuracion/Permisos';
import { ChatOnline } from '../pages/AtencionCliente/ChatOnline';
import { BuzonSugerencias } from '../pages/AtencionCliente/BuzonSugerencias';

import { Calificaciones } from '../pages/AtencionCliente/Calificaciones';
import { CalificacionesConductor } from '../pages/AtencionCliente/CalificacionConductores';
import { CalificacionRecargas } from '../pages/AtencionCliente/CalificacionRecargas';
import { RecargasV2 } from '../pages/Recargas/RecargasV2';
import { Principal } from '../pages/Principal';
import { SocketContext } from '../../context/provider/SocketProvider'
import { notify } from '../../utils/utils'
import { PantallaCarga } from '../pages/AuthorizeWs02IS/Authorization';
import PageNotFound from '../pages/PageNotFound';
import { CentroAyuda } from '../pages/AtencionCliente/CentroAyuda';
import { SugerenciasAC } from '../pages/AtencionCliente/SugerenciasAC'; 

import { OperacionesResumen } from '../pages/OperacionesResumen';
import { Operaciones } from '../pages/Operaciones';
import { Login } from '../pages/Login';
import { ReporteRecargas } from '../pages/Reportes/ReporteRecargas';
import { Reportes } from '../pages/Reportes/Reportes';
import { MovimientosRecarga } from '../pages/MovimientosRecarga';

export function PrivateRoutes({ token }) {
    // export function PrivateRoutes() {

    return (
        <>
            {
                token !== '' && localStorage.getItem('currentLocation') != '/'
                && (
                    <LayoutMaster>
                        <Switch>

                            <PrivateRoute path='/login' component={Login} />
                            <PrivateRoute path='/recargas' component={Recargas} />
                            <PrivateRoute path='/recargasV2' component={RecargasV2} />
                            <PrivateRoute path='/operaciones' component={Operaciones} />
                            <PrivateRoute path='/operacionesResumen' component={OperacionesResumen} />
                            <PrivateRoute path='/usuariosBeex' component={UsuariosAplicativo} />
                            <PrivateRoute path='/profile' component={ProfilePage} />    
                            <PrivateRoute path='/usuariosWeb' component={UsuariosPlataforma} />    
                            <PrivateRoute path='/historial' component={Historial}/>
                            <PrivateRoute path='/personasPlataforma' component={PersonasPlataforma}/>
                            <PrivateRoute path='/enlaceUnidades' component={EnlaceUnidades}/>
                            <PrivateRoute path='/posteos' component={ProfilePage}/>
                            <PrivateRoute path='/permisos' component={Permisos}/>
                            <PrivateRoute path='/libroReclamaciones' component={LibroReclamaciones}/>
                            <PrivateRoute path='/chatOnline' component={ChatOnline}/>
                            <PrivateRoute path='/buzonSugerencias' component={BuzonSugerencias}/>
                            <PrivateRoute path='/calificaciones' component={Calificaciones}/>
                            <PrivateRoute path='/calificacionConductor' component={CalificacionesConductor}/>
                            <PrivateRoute path='/rrecargas' component={ReporteRecargas}/>
                            <PrivateRoute path='/calificacionRecargas' component={CalificacionRecargas}/>
                            <PrivateRoute path='/principal' component={Principal}/>
                            <PrivateRoute path='/centroAyuda' component={CentroAyuda}/>
                            <PrivateRoute path='/sugerencias' component={SugerenciasAC}/>
                            <PrivateRoute path='/consultas-reportes' component={Reportes}/>
                            <PrivateRoute path='/movimientos-recargas' component={MovimientosRecarga}/>
                            {/* <PrivateRoute path='/PantallaCarga' component={PantallaCarga}/> */}

                            <Route path="*" component={PageNotFound}/>
                        </Switch>
                    </LayoutMaster>
                )
            }

        </>
    )
}